module.exports = __webpack_public_path__ + "static/media/ARMAN-AI-03.e6573051.png";